import router from '../router/router';

function subscribeHistory(fn) {
  window.addEventListener('popstate', fn);

  return () => {
    window.removeEventListener('popstate', fn);
  };
}

function syncRouterWithHistory() {
  if (!history) {
    console.error('Warning: window.history is not available.');
    return;
  }

  const unsubscribeHistory = subscribeHistory((e) => {
    if (!e.state) {
      // https://github.com/zeit/next.js/blob/6.0.4-canary.8/lib/router/router.js#L58-L69
      history.replaceState(router.state, null);
      return;
    }

    if (router.state !== e.state) {
      router.pushState(e.state);
    }
  });

  const unsubscribeRouter = router.subscribeState(() => {
    const routeState = router.state;

    if (!history.state || history.state !== routeState) {
      history.pushState(
        routeState,
        null,
        new URL(routeState, window.location.href).href,
      );
    }
  });

  // in order for `e.state` to work on the `onpopstate` event
  // we have to register the initial route upon initialization
  history.replaceState(router.state, null);

  return () => {
    unsubscribeHistory();
    unsubscribeRouter();
  };
}

export default syncRouterWithHistory;
